import initCTAButtons from '../property/cta-buttons';
import initCTACheckboxes from '../property/cta-checkboxes';
import { defaultContactOptions } from '../property/contact-options';
import { validateURLString } from '../url/validate';
import Logger from '../logging/logger';
import initPropertyEnquiryForms from '../property/enquiry';

function onPopupOpenPropertyContact( event: CustomEvent ): void {
    const detail = event.detail || {};
    const container = detail.container || document;

    Logger.info( 'Event Triggered: onPopupOpenPropertyContact', detail );

    initPropertyEnquiryForms();

    initCTACheckboxes( container );

    initCTAButtons( container );

    const checkboxes = container.querySelectorAll( '[data-ts-cta-checkbox]' );
    const btnQuestion = container.querySelector( '[data-ts-cta-action="ask-question"]' );

    const btnOffer = container.querySelector( '[data-ts-cta-action="make-offer"]' );
    const btnOfferValue = document.querySelector<HTMLInputElement>( '[name="offer-quantity"]' );

    function updatesOptions( key, value ) {
        if ( !window.router.previousState.url || !window.router.previousState.isRoutedPopup ) {
            return;
        }

        if ( defaultContactOptions[ key ] === value ) {
            return;
        }

        const previousURL = window.router.previousState.url;

        const url = new URL( previousURL );
        url.searchParams.set( key, value );

        const err = validateURLString( url.toString() );

        if ( err !== null && err.message ) {
            throw new Error( 'validating new contact state URL failed with err: ' + err.message );
        }

        window.router.previousState.url = url.toString();

        if ( !window.router.previousState.meta ) {
            window.router.previousState.meta = {};
        }

        window.router.previousState.meta[ key ] = value;
        window.router.onPopstateMerge = true;
    }

    checkboxes.forEach( function( checkbox ) {
        updatesOptions( checkbox.dataset.tsCtaAction, checkbox.checked );
        checkbox.addEventListener( 'change', function( event ) {
            updatesOptions( event.target.dataset.tsCtaAction, event.target.checked );
        } );
    } );

    if ( btnQuestion ) {
        btnQuestion.addEventListener( 'click', function() {
            updatesOptions( 'ask-question', true );
            updatesOptions( 'text', true );
        },
        {
            once: true,
            passive: true,
        } );
    } else {
        updatesOptions( 'text', true );
    }

    const textarea = container.querySelector( '[name="message"]' );

    if ( textarea ) {
        textarea.addEventListener( 'keyup', function() {
            updatesOptions( 'text', true );
            updatesOptions( 'text-value', textarea.value );
        } );
    }

    if ( btnOffer ) {
        if ( btnOffer.checked ) {
            updatesOptions( 'make-offer', true );
        }

        btnOffer.addEventListener( 'change', function( event ) {
            updatesOptions( 'make-offer', event.target.checked );
        } );
    }

    if ( btnOfferValue ) {
        if ( btnOfferValue.value ) {
            updatesOptions( 'make-offer', true );
            updatesOptions( 'offer-quantity', btnOfferValue.value );
        }

        btnOfferValue.addEventListener( 'keyup', function( event: InputEvent ) {
            updatesOptions( 'offer-quantity', ( ( event.target as HTMLInputElement ).value || '' ).trim().substring( 0, 1000 ) );
        } );
    }
}

export default onPopupOpenPropertyContact;
